import { useLocation } from '@remix-run/react'
import { i18n } from '@lingui/core'

import { Info, Paragraph, Title } from '../text/Text'
import Card from '../ui/Card'

export const ErrorPage = () => {
  const { pathname } = useLocation()
  return (
    <>
      <Title className="mb-4">{i18n._('Leider ist ein Fehler aufgetreten.')}</Title>
      <Paragraph>
        {i18n._('Bitte versuchen Sie es erneut. Klicken Sie dazu')}{' '}
        <a href={pathname} className="underline text-brand">
          {i18n._('hier')}
        </a>{' '}
        {i18n._('oder laden Sie die Seite neu.')}
      </Paragraph>
      <br />
      <Card className="" variant="info">
        <Info>
          {i18n._('Zögern Sie nicht, uns zu kontaktieren, und wenden Sie sich per Mail an')}{' '}
          <a className="text-brand font-bold" href="mailto:feedback@bpam.lu">
            feedback@bpam.lu
          </a>{' '}
          {i18n._('oder per Telefon unter der deutschen Festnetz-Rufnummer')}{' '}
          <a className="text-brand font-bold" href="tel:+89889498525">
            089 - 88 949 85 25
          </a>{' '}
          {i18n._(
            'direkt an uns. Sie erreichen uns unter dieser Nummer zu den üblichen Geschäftszeiten.'
          )}
        </Info>
      </Card>
    </>
  )
}
